import { useQuery } from '@tanstack/react-query'

import type { SiteOnboardingDtoNameEnum } from '@b-stock/account-api-client'

import sites from '@api/sites'

const baseKey = 'getSites'

export const useGetSites = (opts?: { enabled: boolean }) => {
  const queryKey = [baseKey]
  const sitesDataQueryKey = [...queryKey, 'sitesData']

  return useQuery({
    queryKey: sitesDataQueryKey,

    queryFn: async () => {
      const response = await sites.getSites()
      return response
    },

    ...opts,
  })
}

export const useGetSiteOnboardingRequirements = ({
  siteAbb,
}: {
  siteAbb?: string
}) => {
  const data = useGetSites({ enabled: !!siteAbb })
  if (siteAbb === undefined) {
    return null
  }
  const siteData = data?.data
  const site = siteData?.[siteAbb]?.name ?? null
  const onboardingRequirements =
    siteData?.[siteAbb]?.onboardingRequirements ?? null

  return {
    site,
    requirements: onboardingRequirements,
  }
}

type UseGetOnboardingRequirementArg = {
  siteAbb?: string
  requirement: SiteOnboardingDtoNameEnum
}

export const useGetOnboardingRequirement = ({
  siteAbb,
  requirement,
}: UseGetOnboardingRequirementArg) => {
  const siteRequirements = useGetSiteOnboardingRequirements({ siteAbb })

  const site = siteRequirements?.site
  const requirements =
    siteRequirements?.requirements?.find(({ name }) => name === requirement) ??
    null

  return {
    site,
    requirements,
  }
}
